import React from 'react';
import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <div className="state">
      <h4>Page not found</h4>
      <p className="text-small">The page you were looking for does not exist.</p>
      <Link to="/dashboard" className="btn btn-primary btn-sm mt-3">
        Go to dashboard
      </Link>
    </div>
  );
}
